import { useMutation } from '@tanstack/react-query'

import { disableSaml } from '@src/api'
import { DefaultApiDisableSamlRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useDisableSaml = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiDisableSamlRequest) =>
      disableSaml(axiosInstance, params),
  })
}
